import { render, staticRenderFns } from "./objectOfComplaintDialog.vue?vue&type=template&id=58af38f6&scoped=true"
import script from "./objectOfComplaintDialog.vue?vue&type=script&lang=js"
export * from "./objectOfComplaintDialog.vue?vue&type=script&lang=js"
import style0 from "./objectOfComplaintDialog.vue?vue&type=style&index=0&id=58af38f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af38f6",
  null
  
)

export default component.exports